import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/finance',
    children: [
      { path: '', redirect: '/finance/home' },
      { path: 'home', name: 'finance-home', component: () => import('@/modules/finance/FinanceHome.vue') },
      { path: 'ar-aging', name: 'finance-ar', component: () => import('@/modules/finance/ArAging.vue') },
      { path: 'ap-aging', name: 'finance-ap', component: () => import('@/modules/finance/ApAging.vue') },
      { path: 'ap-invoice', name: 'finance-ap-invoice', component: () => import('@/modules/finance/ApInvoiceList.vue') },
      { path: 'ar-invoice', name: 'finance-ar-invoice', component: () => import('@/modules/finance/ArInvoiceList.vue') },
      { path: 'bank-recon', name: 'finance-bank-recon', component: () => import('@/modules/finance/BankRecon.vue') }
    ]
  }
]

export default routes
